import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faAngleDown, faFileExport } from '@fortawesome/free-solid-svg-icons';
import { PageTitle } from "../../../../../_template/layout/core/PageData";
import axios from 'axios';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import SearchForm from './component/SearchForm';
import CardReport from './component/CardReport';
import ReportTable from './component/ReportTable';
import { Pagination, notification, Space } from 'antd';
import { useParams } from "react-router-dom";

const CdrReport = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const ChatReportTitle = [
        {
            title: loginUserType === 'SA' ? 'Agent' : 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: 'Report',
            path: loginUserType === 'SA' ? `${company}/report/cdr-report` : '/report/cdr-report',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const [timezoneData, setTimezoneData] = useState([]);
    const [botData, setBotData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const[summaryData, setSummaryData] = useState({
        totalUser: 0,
        totalDuration: 0,
        totalBot: 0,
        totalInterest: 0
    })
    const [selectedBot, setSelectedBot] = useState(null);
    const [selectedTimezone, setSelectedTimezone] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [page, setPage] = useState(1);
    const dataLimit = 100;
    const [totalRecord, setTotalRecord] = useState(0);

    const [showLoader, setShowLoader] = useState(false);

    useEffect(()=>{
        getAllTimeZone();
        getAllBot();
        setSelectedTimezone(new Date().getTimezoneOffset());
        searchReportHandler();
    },[]);

    const getAllTimeZone = async() => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        
        await axios.post(`${api_base_url}admin/get-all-timezone`, {}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const result = res.data.data.map((item, index) => ({
                    label: item.timezone,
                    value: item.operator+item.offset_in_min
                }));
                setTimezoneData(result);
            } else if(res.data.status === 'error') {
                toast.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    const getAllBot = async() => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        
        await axios.post(`${api_base_url}admin/get-all-bot`, {sass_id : localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const result = res.data.data.map((item, index) => ({
                    label: item.bot_name,
                    value: item.bot_id
                }));
                setBotData(result);
            } else if(res.data.status === 'error') {
                toast.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    var total_record = 0;
    var total_page = 0;
    var page_no = 0;
    const limit = 100;

    var type = "data_count";
    var exportType = '';

    const searchReportHandler = async(event, page_no) =>{
        const api_params = {};
        console.log("========= event ========== ", event)
        if(event) {
            setSelectedBot(event.bot);
            setSelectedTimezone(event.timeOffset);
            setSelectedStartDate(event.searchStartDate);
            setSelectedEndDate(event.searchEndDate);
            api_params.searchStartDate = event.searchStartDate;
            api_params.searchEndDate = event.searchEndDate;
            api_params.bot = event.bot;
            api_params.timeOffset = event.timeOffset;
            setShowLoader(true);
        } else {
            if(selectedStartDate && selectedEndDate && selectedTimezone) {
                api_params.searchStartDate = selectedStartDate;
                api_params.searchEndDate = selectedEndDate;
                api_params.bot = selectedBot;
                api_params.timeOffset = selectedTimezone;
            } else {
                var s_date = dayjs().startOf('day');
                var start_date = new Date(s_date).toLocaleString("en-GB");
                var split_start_data = start_date.split(", ");

                const [day, month, year] = split_start_data[0].split('/');

                const formattedStartDate = `${year}-${month}-${day} ${split_start_data[1]}`;
                setSelectedStartDate(formattedStartDate);
                api_params.searchStartDate = formattedStartDate;

                var e_date = dayjs().endOf('day');
                var end_date = new Date(e_date).toLocaleString("en-GB");
                var split_end_data = end_date.split(", ");

                const [e_day, e_month, e_year] = split_end_data[0].split('/');

                const formattedEndDate = `${e_year}-${e_month}-${e_day} ${split_end_data[1]}`;
                setSelectedEndDate(formattedEndDate);
                api_params.searchEndDate = formattedEndDate;
            
                setSelectedTimezone(new Date().getTimezoneOffset());
                api_params.timeOffset = new Date().getTimezoneOffset();
                api_params.bot = selectedBot;
            }
        }
        
        api_params.sass_id = localStorage.getItem('sass_id');
        api_params.page = page_no ? page_no : page;
        api_params.limit = dataLimit;

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/get-cdr-report`, api_params, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                setTableData([]);
                if(res.data.data.session_data){
                    setTableData(res.data.data.session_data);
                }
                if(res.data.data.summaryData) {
                    const duration = res.data.data.summaryData.total_duration;
                    var final_duration = '';
                    if(duration != "0"){
                        const [hours, minutes, seconds] = duration.split(":");
                        if(hours != '00'){
                            final_duration += hours+" hr ";
                        }
                        if(minutes != '00'){
                            final_duration += minutes+" min";
                        }
                    } else {
                        final_duration = "0";
                    }

                    setSummaryData((prevState)=>{
                        return {
                            ...prevState,
                            totalUser: res.data.data.summaryData.total_session,
                            totalDuration: final_duration,
                            totalBot: res.data.data.summaryData.total_valid_session,
                            totalInterest: res.data.data.summaryData.unique_ip
                        }
                    });
                }
                setTotalRecord(res.data.data.total_count);
                setShowLoader(false);
            } else if(res.data.status === 'error') {
                //toast.error(res.data.message);
                setShowLoader(false);
            }
        })
        .catch((error) => {
            console.error(error);
            setShowLoader(false);
        });
    }
    const onChange = (page) => {
        setPage(page);
        searchReportHandler(null, page);
    };

    const handleExport = async() => {
        const api_params = {};
        api_params.searchStartDate = selectedStartDate;
        api_params.searchEndDate = selectedEndDate;
        api_params.timeOffset = selectedTimezone;
        api_params.sass_id = localStorage.getItem('sass_id');
        api_params.limit = limit;
        api_params.type = type;
        api_params.exportType = exportType;

        api_params.page = page_no;
        api_params.total_page = total_page;

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/get-all-data-for-csv`, api_params, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    if(type === "data_count") {
                        total_record = parseInt(res.data.data.total_data_count);

                        var remainder = (total_record % limit);
                        var quotient = Math.floor(total_record / limit);
                        if(remainder == 0) {
                            total_page = quotient;
                        } else {
                            total_page = (quotient + 1);
                        }
                    }
                    
                    if(total_page > page_no) {
                        type = "data_export";
                        exportType = total_page > 1 ? "multiple" : "";
                        page_no += 1;
                        handleExport();
                    } else {
                        if(res.data.data.is_completed == "yes"){
                            downloadCSV(res.data.data);
                        }
                    }
                }
            })
            .catch((error) => {
                setShowLoader(false);
            })
    };
    const downloadCSV = (data) => {
        const url = api_base_url+data.zip_folder_path;
        
        const link = document.createElement("a");
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(()=>{
            page_no = 0;
            deleteDownloadedFile(data.zip_folder_path);
        },3000)
    };
    const deleteDownloadedFile = async(link) => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/unlink-all-type-file`, {unlink_file_path: link}, api_headers)
            .then(async (res) => {})
            .catch((error) => {})
    }

    /*const convertToCSV = (data) => {
        const headers = [
            'Created At',
            'Updated At',
            'Duration',
            'User Source',
            'Routing',
            'Name',
            'Email',
            'Mobile Number',
            'Enquiry',
            'Status',
            'Intent',
            'Entity',
            'Information',
            'Feedback',
            'External Action',
            'Handover',
            'Transfer on'
        ];

        const rows = data.map(item => [
            item.created_at,
            item.updated_at,
            item.duration,
            item.user_source,
            JSON.stringify(item.routing),
            item.name,
            item.email,
            item.mobile_number,
            JSON.stringify(item.project),
            JSON.stringify(item.status),
            JSON.stringify(item.intent),
            JSON.stringify(item.entity),
            JSON.stringify(item.information),
            JSON.stringify(item.feedback),
            JSON.stringify(item.external_action),
            '',
            ''
        ]);
        const csvContent = [
            headers.join(','),
            ...rows.map(row => row.map(value => `"${value}"`).join(','))
        ].join('\n');

        return csvContent;
    };
    const downloadCSV = (data) => {
        const csv = convertToCSV(data);
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
      
        const link = document.createElement("a");
        link.href = url;
        link.download = "cdr_report_"+selectedStartDate+"-"+selectedEndDate+".csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExport = () => {
        downloadCSV(tableData);
    }; */

    return (
        <>
            <PageTitle breadcrumbs={ChatReportTitle}>CDR Report</PageTitle>
            <div className='row d-none'>
                <CardReport title="Session" sub_title={summaryData.totalUser} />
                <CardReport title="Valid Session" sub_title={summaryData.totalBot} />
                <CardReport title="Duration" sub_title={summaryData.totalDuration} />
                <CardReport title="Unique" sub_title={summaryData.totalInterest} />
            </div>
            <SearchForm 
                timeZone={timezoneData} 
                bot={botData}
                searchReport = {searchReportHandler}
                // searchReport={() => {
                //     setShowLoader(true);
                //     searchReportHandler;
                // }}
                loaderStatus={showLoader} 
            />
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card card-flush border'>
                        <div className="card-header pe-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">
                                    Report Chat
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {totalRecord} chat report are available
                                </span>
                            </h3>
                            <div className='card-toolbar'>
                                {tableData.length > 0 && <button type="button" className="btn btn-dark btn-sm" onClick={handleExport}>
                                    <FontAwesomeIcon icon={faFileExport} /> CSV Export
                                </button>}
                            </div>
                        </div>
                        <div className='card-body py-0'>
                            <ReportTable tableRow={tableData} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <Pagination 
                    align="end" 
                    defaultPageSize={100}
                    defaultCurrent={1} 
                    current={page} 
                    onChange={onChange}
                    total={totalRecord}  
                    hideOnSinglePage={true}
                />
            </div>
        </>   
    )
}

export {CdrReport}